import * as React from 'react';
import { CreateButton, CreateButtonProps } from 'react-admin';
import { Add as AddIcon } from '@mui/icons-material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const CustomCreateButton = (props: CreateButtonProps) => {
    const theme = useTheme();
    // Detecta si estamos en pantalla pequeña (xs o sm)
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    // El label visible para pantallas grandes
    const visibleLabel = props.label === false ? undefined : props.label;

    return (
        <CreateButton
            {...props}
            label={isSmallScreen ? false : visibleLabel}
            icon={<AddIcon />}
            sx={{
                backgroundColor: 'primary.main',
                '&:hover': { backgroundColor: 'primary.dark' },
                flexShrink: 0,
                flexGrow: 0,

                // 🔑 Tamaño fijo en XS para hacerlo redondo
                width: { xs: 40, md: 'auto' },
                height: 40,
                borderRadius: { xs: '50%', md: 0.5 },
                padding: { xs: 0, md: '8px 16px' },

                // 🔑 Fuerza que en XS el botón sea cuadrado/redondo
                '&.MuiButton-root': {
                    minWidth: { xs: 40, md: 64 },
                    minHeight: { xs: 40, md: 40 },
                    justifyContent: { xs: 'center', md: 'initial' },
                    alignItems: 'center',
                },

                ...props.sx,
            }}
        />
    );
};

export default CustomCreateButton;
